<template>
    <section class="sm:px-3 lg:px-60 sm:py-12 py-32 sm:mb-24 text-center background">
        <div class="sm:m-5 py-4 font-medium">
            <h2>{{ title }}</h2>
        </div>
        <div class="sm:m-3 subtitle w-full justify-center items-center flex">
            <p class="lg:w-2/3 sm:w-full">{{ subtitle }}</p>
        </div>
        <div class="grid lg:gap-5 lg:grid-cols-3 grid-cols-1">
            <QuadLayoutSection v-for="(platformfeature, i) of platformfeatures" :title="platformfeature.title"
                :body="platformfeature.body" :icon="platformfeature.icon" :image_url="platformfeature.image_url"
                :total="String(platformfeatures?.length)" :image_40="platformfeature.image_40"
                :rectangular="platformfeature.rectangular" class="rounded-lg sm:px-6 py-8 sm:mt-20 lg:mt-0"
                :class="{ 'col-span-2 lg:col-span-2': platformfeature.rectangular }" />
        </div>
    </section>
</template>

<script lang="ts">
import { type PropType } from 'vue';

export default {
    props: {
        title: String,
        subtitle: String,
        platformfeatures: Array as PropType<{ title?: string; body: string; icon?: string; image_url?: string; image_40?: boolean; rectangular?: boolean }[]>,
    },
};
</script>